var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOeufs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Eggs") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eggs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5,4 C10.6880996,4 12.6236769,6.56725359 13.8016474,9.38507756 C14.6677837,7.99375083 15.7831262,6.96153846 17,6.96153846 C19.7614237,6.96153846 22,12.2770378 22,15.0384615 C22,17.7998853 19.7614237,20.0384615 17,20.0384615 C15.6471612,20.0384615 14.41981,19.501185 13.5196845,18.6283698 C12.3291905,20.0763143 10.5224644,21 8.5,21 C4.91014913,21 2,18.0898509 2,14.5 C2,13.5862198 2.18855842,12.4573062 2.52888881,11.2819886 L2.52888881,11.2819886 L2.6839296,10.7759319 C3.75069954,7.47449151 5.95446938,4 8.5,4 Z M8.5,21 C12.0898509,21 15,18.0898509 15,14.5 C15,13.5862198 14.8114416,12.4573062 14.4711112,11.2819886 L14.3160704,10.7759319 C13.2493005,7.47449151 11.0455306,4 8.5,4 C5.95446938,4 3.75069954,7.47449151 2.6839296,10.7759319 L2.52888881,11.2819886 C2.18855842,12.4573062 2,13.5862198 2,14.5 C2,18.0898509 4.91014913,21 8.5,21 Z",
    id: "Combined-Shape",
    stroke: "#000000"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOeufs);
export default __webpack_public_path__ + "static/media/oeufs.e8d676f97b20d7fb7457e4bae3f029ce.svg";
export { ForwardRef as ReactComponent };